export const SENT = 'SENT';
export const READ = 'READ';